"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx, jsxs } from 'react/jsx-runtime';
import { getNameComponentsForLocator, getFullNameForLocator } from '@membranehq/sdk';
import { EditorTagBadge, EditorTagBadgeIcon } from '../../ComboBox/Badges/EditorTagBadge/index.mjs';
import { NestedBadgeValue } from '../../ComboBox/Badges/EditorTagBadge/NestedBadgeValue.mjs';
import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';
import { Tooltip } from '../../Tooltip/index.mjs';
import { forwardRef } from 'react';

const VarFormula = forwardRef((props, ref) => {
  const { formula, variablesSchema } = props;
  const nameComponents = getNameComponentsForLocator(variablesSchema, formula.locator);
  if (nameComponents === void 0) {
    return /* @__PURE__ */ jsx(Tooltip, { tooltip: "Source variable doesn't exist", usePortal: true, children: /* @__PURE__ */ jsxs(EditorTagBadge, { variant: "error", onDelete: props.onDelete, children: [
      /* @__PURE__ */ jsx(EditorTagBadgeIcon, { type: SvgIconType.Unlink }),
      formula.locator
    ] }) });
  }
  const fullName = getFullNameForLocator(variablesSchema, formula.locator) || "Unknown Var";
  return /* @__PURE__ */ jsx(EditorTagBadge, { ref, disabled: props.disabled, onClick: props.onClick, onDelete: props.onDelete, children: /* @__PURE__ */ jsx(NestedBadgeValue, { nameChunks: nameComponents, fullName }) });
});
VarFormula.displayName = "VarFormula";

export { VarFormula as default };
